import React, { Component } from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';

import { AdminNav } from '../../helpers';

import './StyleAdmin.css';

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Container>
          <AdminNav></AdminNav>
        <Link to="/requestTable">
          <Button className="btn-space" variant="primary" size="lg" block>
            แจ้งขอตรวจสอบ
          </Button>
        </Link>
        <Link to="/RequestDaily">
          <Button className="btn-space" variant="primary" size="lg" block>
            บันทึกรับแจ้ง
          </Button>
        </Link>
        <Link to="/CheckWeightTable">
          <Button className="btn-space" variant="primary" size="lg" block>
            Checkweight
          </Button>
        </Link>
        <Link to="/FinancialAccount">
          <Button className="btn-space" variant="primary" size="lg" block>
            คำนวนค่าแรง
          </Button>
        </Link>

        <Link to="/ValidPage">
          <Button className="btn-space" variant="primary" size="lg" block>
            ส่วนวิเคราะห์
          </Button>
        </Link>

        <Link to="/CertificateCalendar">
          <Button className="btn-space" variant="primary" size="lg" block>
            ใบรับรอง
          </Button>
        </Link>
        <Link to="/Statistics">
          <Button className="btn-space" variant="primary" size="lg" block>
            สถิติ
          </Button>
        </Link>
      </Container>
    );
  }
}
export default withRouter(Admin);
